export default "/images/97e1b271279aecd09ef5e857280a9f5f.avif";